function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import businessDomainService from '@/apps/data-platform/services/master_data/business_domain_service';
import businessSubdomainService from '@/apps/data-platform/services/master_data/business_subdomain_service';
import tasks from '@/js/tasks';
export default {
  name: 'BusinessDomain',
  data: function data() {
    return {
      organization: '',
      kdomain: '',
      domain: '',
      definition: '',
      organizationSub: '',
      kdomainSub: '',
      ksubdomainSub: '',
      subdomainSub: '',
      definitionSub: '',
      selectBusinessDomain: [],
      selectbusinessSubdomain: [],
      MODAL_NAME_ACCESS: 'business-term-tpl',
      MODAL_DESCRIPTTION: 'Representa un medio para compartir vocabulario interno dentro de una organización',
      modalId: 'dp_BusinessDomain',
      modalName: 'Business Domain',
      subdomains: [],
      terms: [],
      registers: [],
      tree: [],
      tplToUpdate: {},
      datos: [],
      wrnng: '',
      cDomain: '',
      selectDomain: [],
      cRoles: [],
      cEmail: '',
      itemDelete: '',
      filter_enabled: true,
      tab: null,
      pagination: {
        current: 1,
        limit: 10,
        total: 0
      },
      pagination2: {
        current: 1,
        limit: 10,
        total: 0
      },
      filter: '',
      filter2: '',
      text_filter: '',
      key_table1: 1,
      key_table2: 1
    };
  },
  computed: {
    selectbusinessSubdomainField: function selectbusinessSubdomainField() {
      return [{
        thStyle: {
          width: '120px !important'
        },
        value: 'domain',
        text: this.traductor('tablas.domain'),
        class: 'titulo',
        align: "center"
      }, {
        thStyle: {
          width: '120px !important'
        },
        value: 'subdomain',
        text: this.traductor('filtros.subdomain'),
        class: 'titulo',
        align: "center"
      }, {
        value: 'definition',
        text: this.traductor('tablas.definition'),
        class: 'titulo'
      }, {
        thStyle: {
          width: '90px !important'
        },
        value: 'update_date',
        text: this.traductor('tabla_segmentos.mod'),
        class: 'titulo',
        align: 'center'
      }, {
        thStyle: {
          width: '80px !important'
        },
        value: 'navigator',
        text: this.traductor('tablas.actions'),
        class: 'titulo',
        align: 'center'
      }];
    },
    selectBusinessDomainFields: function selectBusinessDomainFields() {
      return [{
        thStyle: {
          width: '120px !important'
        },
        value: 'domain',
        text: this.traductor('tablas.domain'),
        class: 'titulo',
        align: "center"
      }, {
        value: 'definition',
        text: this.traductor('tablas.definition'),
        class: 'titulo'
      }, {
        thStyle: {
          width: '90px !important'
        },
        value: 'update_date',
        text: this.traductor('tabla_segmentos.mod'),
        class: 'titulo',
        align: 'center'
      }, {
        thStyle: {
          width: '80px !important'
        },
        value: 'navigator',
        text: this.traductor('tablas.actions'),
        class: 'titulo',
        align: 'center'
      }];
    },
    texts: function texts() {
      return {
        domain: this.traductor('tablas.domain'),
        definition: this.traductor('tablas.definition'),
        subdomain: this.traductor('filtros.subdomain'),
        bdomain: this.traductor('menu.config.business_domains'),
        bsubdomain: this.traductor('frases.subdomain'),
        delete_bdomain: this.traductor('frases.delete_bdomain'),
        delete_bsubdomain: this.traductor('frases.delete_bsubdomain')
      };
    },
    filterBusinessDomain: function filterBusinessDomain() {
      var i;
      var selectBusinessDomain = [];
      for (i = 0; i < this.selectBusinessDomain.length; i++) {
        selectBusinessDomain.push({
          value: this.selectBusinessDomain[i].kdomain,
          text: this.selectBusinessDomain[i].domain
        });
      }
      return selectBusinessDomain;
    }
  },
  created: function created() {
    this.fmount(true, false);
  },
  methods: {
    onchangeTab: function onchangeTab() {
      if (this.tab == 0) {
        this.text_filter = this.filter;
      } else {
        this.text_filter = this.filter2;
      }
    },
    onSearch: function onSearch() {
      if (this.tab == 0) this.filter = this.text_filter;else this.filter2 = this.text_filter;
    },
    onLimpiar: function onLimpiar() {
      if (this.tab == 0) this.filter = '';else this.filter2 = '';
      this.text_filter = '';
    },
    onEnableFilter: function onEnableFilter() {
      this.filter_enabled = !this.filter_enabled;
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    refresh: function refresh() {
      this.fmount(false, false);
    },
    fmount: function fmount(appendDomain, Iresponse) {
      this.userInfo = tasks.getUserInfo();
      this.cRoles = this.userInfo.userRoles;
      this.cDomain = this.userInfo.domain;
      this.selectBusinessDomainLog();
    },
    selectBusinessDomainLog: function selectBusinessDomainLog() {
      var _this = this;
      var iResponse, i, index;
      var businessDomain = {
        domain: this.cDomain
      };
      businessDomainService.getBusinessDomains(businessDomain).then(function (response) {
        iResponse = response;
      }).then(function () {
        _this.selectBusinessDomain = iResponse.data.result;
        _this.pagination.total = _this.selectBusinessDomain.length;
      }).then(function () {
        businessSubdomainService.getBusinessSubdomains(businessDomain).then(function (response) {
          iResponse = response;
        }).then(function () {
          _this.selectbusinessSubdomain = iResponse.data.result;
          _this.pagination2.total = _this.selectbusinessSubdomain.length;
          if (_this.selectbusinessSubdomain) {
            for (i = 0; i < _this.selectbusinessSubdomain.length; i++) {
              index = _this.selectBusinessDomain.findIndex(function (Subdomain) {
                return Subdomain.kdomain.includes(_this.selectbusinessSubdomain[i].kdomain);
              });
              if (index !== -1) {
                _this.selectbusinessSubdomain[i].domain = _this.selectBusinessDomain[index].domain;
              } else {
                _this.selectbusinessSubdomain[i].domain = 'Undefined';
                _this.selectbusinessSubdomain[i].kdomain = 'Undefined';
              }
            }
          }
        });
      });
    },
    acceptModalFcreDomain: function acceptModalFcreDomain(event) {
      var _this2 = this;
      event.preventDefault();
      if (this.domain && this.definition) {
        var bterm = this.domain;
        var lower = bterm.toLowerCase();
        var upper = bterm.toUpperCase();
        var approbe = '0123456789 .-';
        var res = '';
        for (var i = 0; i < lower.length; ++i) {
          if (lower[i] !== upper[i] || approbe.includes(lower[i])) {
            res += upper[i];
          }
        }
        this.domain = res;
        var businessDomain = {
          domain: this.cDomain,
          clauses: {
            domain: this.domain
          }
        };
        businessDomainService.getBusinessDomains(businessDomain).then(function (response) {
          if (response.data.result.length !== 0) {
            if (!(_this2.kdomain === response.data.result[0].kdomain)) {
              //alert('Business domain already exists')
              tasks.toast.error('Business domain already exists');
            } else {
              _this2.insertEditBusinessDomain(_this2.kdomain);
              _this2.$refs['domain-modal'].onClose();
            }
          } else {
            _this2.insertEditBusinessDomain(_this2.kdomain);
            _this2.$refs['domain-modal'].onClose();
          }
        });
      } else if (!this.domain) {
        tasks.toast.error('Complete the business domain');
        //alert('Complete the business domain')
      } else if (!this.definition) {
        tasks.toast.error('Complete the business domain definition');
        //alert('Complete the business domain definition')
      }
    },
    cancelModalFcreDoamin: function cancelModalFcreDoamin(event) {
      event.preventDefault();
      this.$refs['domain-modal'].onClose();
    },
    refreshModalDomain: function refreshModalDomain() {
      this.domain = '';
      this.kdomain = '';
      this.definition = '';
    },
    onNuevoDomain: function onNuevoDomain() {
      this.refreshModalDomain();
      this.$refs["domain-modal"].onOpen();
    },
    acceptModalFcreSubdomain: function acceptModalFcreSubdomain(event) {
      var _this3 = this;
      event.preventDefault();
      if (this.subdomainSub && this.definitionSub) {
        var bterm = this.subdomainSub;
        var lower = bterm.toLowerCase();
        var upper = bterm.toUpperCase();
        var approbe = '0123456789 .-';
        var res = '';
        for (var i = 0; i < lower.length; ++i) {
          if (lower[i] !== upper[i] || approbe.includes(lower[i])) {
            res += upper[i];
          }
        }
        this.subdomainSub = res;
        var businessSubdomain = {
          domain: this.cDomain,
          clauses: {
            subdomain: this.subdomainSub
          }
        };
        businessSubdomainService.getBusinessSubdomains(businessSubdomain).then(function (response) {
          if (response.data.result.length !== 0) {
            if (!(_this3.ksubdomainSub === response.data.result[0].ksubdomain)) {
              tasks.toast.error('Business subdomain already exists');
              //alert('Business subdomain already exists')
            } else {
              _this3.insertEditBusinessSubdomain(_this3.ksubdomainSub);
              _this3.$refs['subdomain-modal'].onClose();
            }
          } else {
            _this3.insertEditBusinessSubdomain(null);
            _this3.$refs['subdomain-modal'].onClose();
          }
        });
      } else if (!this.subdomainSub) {
        tasks.toast.error('Complete the business domain');
        //alert('Complete the business domain')
      } else if (!this.definitionSub) {
        tasks.toast.error('Complete the business domain definition');
        //alert('Complete the business domain definition')
      }
    },
    cancelModalFcreSubdoamin: function cancelModalFcreSubdoamin(event) {
      event.preventDefault();
      this.refreshModalSubdomain();
      this.$refs['subdomain-modal'].onClose();
    },
    refreshModalSubdomain: function refreshModalSubdomain() {
      this.kdomainSub = '';
      this.ksubdomainSub = '';
      this.subdomainSub = '';
      this.definitionSub = '';
    },
    onNuevoSubdomain: function onNuevoSubdomain() {
      this.refreshModalSubdomain();
      this.$refs["subdomain-modal"].onOpen();
    },
    acceptModalFdelDomain: function acceptModalFdelDomain(event) {
      if (!event) {
        this.$refs['delDom-modal'].onClose();
        return;
      }
      if (this.itemDelete) {
        this.deleteBusinessDomain();
        this.$refs['delDom-modal'].onClose();
      }
    },
    cancelModalFdelDomain: function cancelModalFdelDomain(event) {
      event.preventDefault();
      this.$refs['delDom-modal'].onClose();
    },
    assignDelBDom: function assignDelBDom(domain) {
      this.itemDelete = domain;
      this.$refs["delDom-modal"].onOpen();
    },
    deleteBusinessDomain: function deleteBusinessDomain() {
      var _this4 = this;
      var i;
      var index = this.selectBusinessDomain.findIndex(function (domain) {
        return domain.kdomain.includes(_this4.itemDelete.kdomain);
      });
      var businessDomain = {
        domain: this.cDomain,
        kdomain: this.itemDelete.kdomain
      };
      businessDomainService.businessDomainDelete(businessDomain).then(function (response) {
        if (response.success) {
          tasks.toast.success('El registro se eliminó correctamente');
          _this4.selectBusinessDomain.splice(index, 1);
          for (i = 0; i < _this4.selectbusinessSubdomain.length; i++) {
            if (_this4.selectbusinessSubdomain[i].kdomain === _this4.itemDelete.kdomain) {
              _this4.businessSubdomainsDelete(_this4.selectbusinessSubdomain[i].ksubdomain);
            }
          }
          //this.$refs.subdomaintable.refresh()
          _this4.key_table2 += 1;
        } else {
          tasks.toast.error('No se pudo eliminar el registro, inténtelo nuevamente en unos minutos.');
        }
      });
    },
    acceptModalFdelSubdomain: function acceptModalFdelSubdomain(event) {
      if (!event) {
        this.$refs['delSubdom-modal'].onClose();
        return;
      }
      if (this.itemDelete) {
        this.deleteBusinessSubdomain();
        this.$refs['delSubdom-modal'].onClose();
      }
    },
    cancelModalFdelSubdomain: function cancelModalFdelSubdomain(event) {
      event.preventDefault();
      this.$refs['delSubdom-modal'].onClose();
    },
    assignDelBSubdom: function assignDelBSubdom(subdomain) {
      this.itemDelete = subdomain;
      this.$refs["delSubdom-modal"].onOpen();
    },
    deleteBusinessSubdomain: function deleteBusinessSubdomain() {
      this.businessSubdomainsDelete(this.itemDelete.ksubdomain);
    },
    businessSubdomainsDelete: function businessSubdomainsDelete(ksubdomain) {
      var _this5 = this;
      var index = this.selectbusinessSubdomain.findIndex(function (Subdomain) {
        return Subdomain.ksubdomain.includes(ksubdomain);
      });
      console.log(this.selectbusinessSubdomain, ksubdomain, index);
      var businessSubdomain = _defineProperty({
        domain: this.cDomain,
        document_id: this.itemDelete.document_id,
        ksubdomain: ksubdomain,
        kdomain: this.selectbusinessSubdomain[index].kdomain
      }, "document_id", this.selectbusinessSubdomain[index].document_id);
      businessSubdomainService.businessSubdomainDelete(businessSubdomain).then(function (response) {
        if (response.success) {
          tasks.toast.success('El registro se eliminó correctamente.');
          _this5.selectbusinessSubdomain.splice(index, 1);
        } else {
          tasks.toast.error('No se pudo eliminar el registro, inténtelo nuevamente.');
        }
      });
    },
    insertEditBusinessDomain: function insertEditBusinessDomain(kdomain) {
      var _this6 = this;
      var i;
      var now = new Date().toISOString().slice(0, 10);
      var businessDomain = {
        domain: this.cDomain,
        business_domain: {
          definition: this.definition,
          domain: this.domain,
          kdomain: kdomain,
          organization: this.cDomain,
          params: '',
          update_date: now
        }
      };
      businessDomainService.businessDomainAddUpdate(businessDomain).then(function (response) {
        if (response.success) {
          tasks.toast.success('El registro se guardó correctamente.', 'Éxito', "");
          if (kdomain) {
            var index = _this6.selectBusinessDomain.findIndex(function (Subdomain) {
              return Subdomain.kdomain.includes(kdomain);
            });
            _this6.selectBusinessDomain[index].definition = _this6.definition;
            _this6.selectBusinessDomain[index].domain = _this6.domain;
          } else {
            _this6.selectBusinessDomain.push(response.data.business_domain);
          }
          for (i = 0; i < _this6.selectbusinessSubdomain.length; i++) {
            if (_this6.selectbusinessSubdomain[i].kdomain === kdomain) {
              _this6.selectbusinessSubdomain[i].domain = _this6.domain;
            }
          }
          //this.$refs['subdomaintable'].refresh()
          _this6.key_table2 += 1;
          _this6.refreshModalDomain();
        } else {
          tasks.toast.error('No se pudo guardar el registro, inténtelo nuevamente.');
        }
      });
    },
    insertEditBusinessSubdomain: function insertEditBusinessSubdomain(ksubdomain) {
      var _this7 = this;
      var isEdit = !!ksubdomain;
      var now = new Date().toISOString().slice(0, 10);
      var businessDomain = {
        domain: this.cDomain,
        business_subdomain: {
          organization: this.cDomain,
          kdomain: this.kdomainSub,
          ksubdomain: isEdit ? ksubdomain : null,
          subdomain: this.subdomainSub,
          definition: this.definitionSub,
          update_date: now,
          params: ''
        }
      };
      businessSubdomainService.businessSubdomainAddUpdate(businessDomain).then(function (response) {
        if (response.success) {
          tasks.toast.success('Se guardó el registro correctamente.');
          if (ksubdomain) {
            var indexDom = _this7.selectBusinessDomain.findIndex(function (Subdomain) {
              return Subdomain.kdomain.includes(response.data.business_subdomain.kdomain);
            });
            var index = _this7.selectbusinessSubdomain.findIndex(function (Subdomain) {
              return Subdomain.ksubdomain.includes(ksubdomain);
            });
            var domain = _this7.selectBusinessDomain[indexDom].domain;
            _this7.selectbusinessSubdomain[index].definition = _this7.definitionSub;
            _this7.selectbusinessSubdomain[index].subdomain = _this7.subdomainSub;
            _this7.selectbusinessSubdomain[index].kdomain = _this7.kdomainSub;
            _this7.selectbusinessSubdomain[index].domain = domain;
          } else {
            var _index = _this7.selectBusinessDomain.findIndex(function (Subdomain) {
              return Subdomain.kdomain.includes(response.data.business_subdomain.kdomain);
            });
            _this7.selectbusinessSubdomain.push({
              definition: response.data.business_subdomain.definition,
              kdomain: response.data.business_subdomain.kdomain,
              ksubdomain: response.data.business_subdomain.ksubdomain,
              organization: response.data.business_subdomain.organization,
              params: response.data.business_subdomain.params,
              subdomain: response.data.business_subdomain.subdomain,
              update_date: response.data.business_subdomain.update_date,
              domain: _this7.selectBusinessDomain[_index].domain
            });
          }
          //this.$refs.subdomaintable.refresh()
          _this7.key_table2 += 1;
          _this7.refreshModalSubdomain();
        } else {
          tasks.toast.error('No se pudo guardar el registro, inténtelo en unos minutos.');
        }
      });
    },
    updateBusinessDomain: function updateBusinessDomain(kdomain, domain, definition) {
      this.kdomain = kdomain;
      this.domain = domain;
      this.definition = definition;
      this.$refs["domain-modal"].onOpen();
    },
    updateBusinessSubdomain: function updateBusinessSubdomain(kdomain, ksubdomain, subdomain, definition) {
      this.kdomainSub = kdomain;
      this.ksubdomainSub = ksubdomain;
      this.subdomainSub = subdomain;
      this.definitionSub = definition;
      this.$refs["subdomain-modal"].onOpen();
    },
    onDownload: function onDownload() {}
  }
};